import {ActionTree} from 'vuex';
import {ProductHistory, ProductItem, ProductsState, RootState, SoftwareItem} from '@/types';
import * as types from './types';
import axios from 'axios';
import {productIconMap} from '@/constants/productIcons';
import {ProductType} from '@/constants/productTypes';
import {
  API_ACTIVATE_PRODUCT_URL,
  API_GET_PRODUCT_CONTRACTS_URL,
  API_GET_PRODUCT_HISTORY_URL,
  API_GET_PRODUCTS_URL,
  API_GET_SOFTWARE_URL,
} from '@/constants/api';

const actions: ActionTree<ProductsState, RootState> = {

  async fetchProducts({ commit, dispatch, rootGetters }, type: ProductType) {
    try {
      const {uuid} = rootGetters;
      const {data} = await axios.get(API_GET_PRODUCTS_URL(uuid, type));
      commit(types.SET_PRODUCTS, { type: type, data: data });
      commit(types.SET_PRODUCTS_TYPE, type);

      const { content } = data;
      if (content/* && content.length <= MANUALLY_LOAD_THRESHOLD*/) {
        content.forEach((url: string) => dispatch('fetchProduct', { url: url, type: type }));
      }
    } catch (error) {
      throw new Error(error);
    }
  },

  async fetchProduct({ commit, dispatch }, { url, type }) {
    try {
      const item: ProductItem | SoftwareItem = await axios.get(url)
          .then((response) => {
            const item: ProductItem | SoftwareItem = response.data;
            // if instanceof ProductItem and not already of type ProductType
            if ('model' in item && !item.model.category.defaultIcon) {
              item.model.category = ProductType.of(response.data.model.category)!;
            }
            return item;
          });
      const modifiedData = getModifiedData(item);
      if ('uuid' in item && (type === ProductType.DRONE || type === ProductType.CENTRAL_BODY)) {
        dispatch('fetchProductContracts', { productUuid: item.uuid, type });
      }
      commit(types.SET_PRODUCT, { data: modifiedData, type: type });
    } catch (error) {
      throw new Error(error);
    }
  },

  async fetchProductHistory({ commit }, product: ProductItem) {
    try {
      const {data: page} = await axios.get<ProductHistory>(API_GET_PRODUCT_HISTORY_URL(product.uuid));
      commit(types.SET_PRODUCT_HISTORY, { page, product });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.DISPLAY_PRODUCT_HISTORY, product);
    }
  },

  async fetchProductContracts({ commit }, { productUuid, type }) {
    try {
      const url = API_GET_PRODUCT_CONTRACTS_URL(productUuid);
      const {data} = await axios.get(url);

      commit(types.SET_PRODUCT_CONTRACTS, { data, productUuid, type });
    } catch (error) {
      throw new Error(error);
    }
  },

  async activateSoftware({ commit, dispatch }, software: SoftwareItem) {
    try {
      commit(types.REFRESH_SOFTWARE, { ...software, isActivating: true });

      await axios.post<ProductItem>(API_ACTIVATE_PRODUCT_URL(software.productUuid));
      const { data } = await axios.get<SoftwareItem>(API_GET_SOFTWARE_URL(software.productUuid));
      commit(types.REFRESH_SOFTWARE, { ...software, ...data });

    } catch (error) {
      commit(types.REFRESH_SOFTWARE, { ...software, isActivating: false });
      throw new Error(error);
    }
  },

};

const getModifiedData = (item: ProductItem | SoftwareItem) => {
  if ('model' in item) { // instanceof ProductItem
    const {model} = item;
    const icon = productIconMap[model.familyId] || model.category.defaultIcon;
    return {
      ...item,
      warrantyEndDate: item.warrantyEndDate || '-----',
      model: { ...model, icon },
      history: {},
      isHistoryDisplayed: false,
      contracts: {},
    };
  }

  const icon = productIconMap[item.id] || 'EMotionIcon';
  return { ...item, model: { icon } };
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/products/actions.ts